import {currentFormatter, dateFormatter, integerFormatter, numberFormatter} from "../../gridFormatters";
import { wtAvg } from "../../math";

export const enterpriseHostDefs = [
    {
        "field": "device_type_code",
        "headerName": "Device Type",
        "hide": true,
        "enableRowGroup": true,
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "current",
        "cellRenderer": currentFormatter,
        "headerName": "Days Old",
        "type": "numericColumn",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "cellStyle": {
            "textAlign": "center"
        },
        "hide": true,
    },
    {
        "field": "host_name",
        "headerName": "Host Name",
        "enableRowGroup": true,
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "host_os",
        "headerName": "Host OS",
        "enableRowGroup": true,
    },
    {
        "field": "application",
        "headerName": "Application",
        "enableRowGroup": true,
        "hide": true
    },
    {
        "field": "device_name",
        "headerName": "Device Name",
        "enableRowGroup": true,
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "last_backup",
        "headerName": "Last Backup",
        "cellRenderer": dateFormatter,
        "hide": true
    },
    {
        "field": "machine_type",
        "headerName": "Machine Type",
        "hide": true,
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "connected_switches",
        "headerName": "Connected Switches",
        "type": "numericColumn",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "total_stored_gb",
        "headerName": "Total Stored ",
        "type": "numericColumn",
        "hide": true,
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
    },
    {
        "field": "total_lun_size",
        "type": "numericColumn",
        "headerName": "LUN Size",
        "cellRenderer": numberFormatter,
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "aggFunc": "sum"
    },
    {
        "field": "total_lun_used",
        "type": "numericColumn",
        "headerName": "Used",
        "cellRenderer": numberFormatter,
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "aggFunc": "sum"
    },
    {
        "field": "luns_attached",
        "cellRenderer": integerFormatter,
        "type": "numericColumn",
        "headerName": "LUNs Attached",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "aggFunc": "sum"
    },
    {
        "field": "iops",
        "type": "numericColumn",
        "headerName": "IOPS",
        "cellRenderer": numberFormatter,
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "aggFunc": "sum"
    },
    {
        "field": "latency",
        "type": "numericColumn",
        "cellRenderer": numberFormatter,
        "headerName": "Read Latency",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "aggFunc": p => wtAvg(p, "latency", "iops")
    },
    {
        "field": "read_mb_sec",
        "headerName": "Read MB/Sec",
        "cellRenderer": numberFormatter,
        "type": "numericColumn",
        "hide": true,
        "enableRowGroup": true,
        "enableValue": true,
        "cellStyle": {
            "text-align": "right"
        },
        "aggFunc": "sum"
    },
    {
        "field": "write_mb_sec",
        "headerName": "Write MB/Sec",
        "cellRenderer": numberFormatter,
        "type": "numericColumn",
        "hide": true,
        "enableRowGroup": true,
        "enableValue": true,
        "cellStyle": {
            "text-align": "right"
        },
        "aggFunc": "sum"
    },
    {
        "field": "total_mb_sec",
        "headerName": "Total MB/Sec",
        "cellRenderer": numberFormatter,
        "type": "numericColumn",
        "hide": true,
        "enableRowGroup": true,
        "enableValue": true,
        "cellStyle": {
            "text-align": "right"
        },
        "aggFunc": "sum"
    },
    {
        "field": "avg_latency",
        "type": "numericColumn",
        "cellRenderer": numberFormatter,
        "headerName": "Avg Latency",
        "filter": "agNumberColumnFilter",
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        },
        "aggFunc": p => wtAvg(p, "avg_latency", "iops")
    },
    {
        "field": "data_center",
        "headerName": "Data Center",
        "enableRowGroup": true,
        "hide": true,
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "application",
        "headerName": "Application",
        "enableRowGroup": true,
        "hide": true,
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "classification",
        "headerName": "Classification",
        "enableRowGroup": true,
        "hide": true,
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
    {
        "field": "geography",
        "headerName": "Geography",
        "enableRowGroup": true,
         "hide": true,
        "filterParams": {
            "cellHeight": 20,
            "debounceMs": 1000
        }
    },
]
